/* Enduristan NL restyle 2026: EN Evenementen v3.1 (sections/en-events.liquid).
   Zet de tabel uit de pagina-inhoud om naar kaarten per maand.
   v2: datums lezen, afgelopen markeren, datumzoeker (maandknoppen, datumveld, eerstvolgend evenement).
   v3: komende evenementen bovenaan (chronologisch), afgelopen evenementen onderaan in een uitklapblok
       (standaard dicht; past_mode bottom / bottom_open / mark / hide). Datumzoeker opent het blok zo nodig.
   v3.1 (29-10-2026): NL/EN. Taal uit Shopify.locale (of html lang). Engels: Engelse maandnamen en landnamen zoals in de
       bron (Engels), alleen Bosnia wordt Bosnia and Herzegovina. */
(function () {
  var EN = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var MONTHS = { january: 0, januari: 0, february: 1, februari: 1, march: 2, maart: 2, april: 3, may: 4, mei: 4, june: 5, juni: 5, july: 6, juli: 6, august: 7, augustus: 7, september: 8, october: 9, oktober: 9, november: 10, december: 11 };
  var MNAME = EN
    ? ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    : ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
  var MSHORT = EN
    ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    : ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var COUNTRIES = EN
    ? { 'the netherlands': 'Netherlands', 'nederland': 'Netherlands', 'denmark/sweden': 'Denmark / Sweden', 'bosnia': 'Bosnia and Herzegovina' }
    : { 'netherlands': 'Nederland', 'the netherlands': 'Nederland', 'switzerland': 'Zwitserland', 'croatia': 'Kroatië', 'romania': 'Roemenië', 'denmark': 'Denemarken', 'sweden': 'Zweden', 'denmark/sweden': 'Denemarken / Zweden', 'italy': 'Italië', 'germany': 'Duitsland', 'austria': 'Oostenrijk', 'united kingdom': 'Verenigd Koninkrijk', 'poland': 'Polen', 'france': 'Frankrijk', 'spain': 'Spanje', 'belgium': 'België', 'slovenia': 'Slovenië', 'norway': 'Noorwegen', 'finland': 'Finland', 'czech republic': 'Tsjechië', 'portugal': 'Portugal', 'greece': 'Griekenland', 'montenegro': 'Montenegro', 'bosnia': 'Bosnië en Herzegovina' };
  var NL_NAMES = ['netherlands', 'the netherlands', 'nederland'];
  var PIN = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.4"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 17L17 7M9 7h8v8"/></svg>';

  function txt(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function safeUrl(u) { return /^(https?:)?\/\//i.test(u || '') || /^\//.test(u || '') ? u : ''; }
  function yr(y) { y = parseInt(y, 10); return y < 100 ? 2000 + y : y; }
  function day(y, m, d) { return new Date(y, m, d); }
  function fmt(d) { return d.getDate() + ' ' + MSHORT[d.getMonth()] + ' ' + d.getFullYear(); }
  function fill(tpl, map) { return String(tpl || '').replace(/\[(\w+)\]/g, function (a, k) { return map[k] != null ? map[k] : a; }); }

  function parseDates(s) {
    var r = /(\d{1,2})(?:\.(\d{1,2}))?\.?\s*[-–]\s*(\d{1,2})\.(\d{1,2})\.(\d{2,4})/.exec(s);
    if (r) {
      var y = yr(r[5]), m2 = parseInt(r[4], 10) - 1, m1 = r[2] ? parseInt(r[2], 10) - 1 : m2;
      var y1 = m1 > m2 ? y - 1 : y;
      return { start: day(y1, m1, parseInt(r[1], 10)), end: day(y, m2, parseInt(r[3], 10)) };
    }
    r = /(\d{1,2})\.(\d{1,2})\.(\d{2,4})/.exec(s);
    if (r) { var d = day(yr(r[3]), parseInt(r[2], 10) - 1, parseInt(r[1], 10)); return { start: d, end: d }; }
    return null;
  }

  /* Sorteersleutel: startdatum, anders einde van de maand (datum volgt), anders volgorde in de lijst */
  function sortKey(i) {
    if (i.dates) return i.dates.start.getTime();
    if (i.year && i.month.idx > -1) return day(i.year, i.month.idx + 1, 0).getTime();
    return Infinity;
  }

  function build(root) {
    var src = root.querySelector('[data-en-ev-src]');
    var list = root.querySelector('[data-en-ev-list]');
    if (!src || !list) return;
    var rows = src.querySelectorAll('tr');
    if (!rows.length) return;
    var L = root.dataset;
    var mode = L.pastMode || 'bottom';
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var months = [];
    var cur = null;
    var all = [];

    rows.forEach(function (tr) {
      var c = tr.querySelectorAll('td, th');
      if (c.length < 3) return;
      var first = txt(c[0]);
      var rest = '';
      for (var i = 1; i < c.length; i++) rest += txt(c[i]);
      if (!first && !rest) return;
      var key = first.toLowerCase();
      if (!rest && (MONTHS[key] != null || c[0].querySelector('strong, b'))) {
        var mi = MONTHS[key] != null ? MONTHS[key] : -1;
        cur = { n: months.length, idx: mi, name: mi > -1 ? MNAME[mi] : first, items: [] };
        months.push(cur);
        return;
      }
      if (!cur) { cur = { n: months.length, idx: -1, name: '', items: [] }; months.push(cur); }

      var country = txt(c[1]);
      var cKey = country.toLowerCase();
      var evCell = c[2];
      var a = evCell.querySelector('a');
      var full = txt(evCell);
      var name, place;
      if (a && txt(a)) {
        name = txt(a);
        place = full.indexOf(name) === 0 ? full.slice(name.length) : full.replace(name, '');
      } else {
        var parts = full.split(/,\s*/);
        name = parts.shift();
        place = parts.join(', ');
      }
      name = name.replace(/\s*[-–]\s*DONE\s*$/i, '');
      place = place.replace(/^[\s,\-–]+/, '').trim();
      var href = a ? safeUrl(a.getAttribute('href')) : '';

      var hosts = [];
      if (c[3]) {
        var links = c[3].querySelectorAll('a');
        if (links.length) {
          links.forEach(function (l) { hosts.push({ name: txt(l), href: safeUrl(l.getAttribute('href')) }); });
        } else {
          var h = txt(c[3]).replace(/^(hosted by|stand van|door)\s*/i, '');
          if (h) hosts.push({ name: h, href: '' });
        }
      }
      var dates = parseDates(first);
      var dateTxt = first.replace(/\bTBD\b/gi, '(' + (L.lTbd || (EN ? 'date to be confirmed' : 'datum volgt')) + ')').replace(/\s+/g, ' ').trim();
      if (dates) dateTxt = dateTxt.replace(/(\d{1,2})\.\s*-/g, '$1-');
      var isNl = NL_NAMES.indexOf(cKey) > -1 || hosts.some(function (h) { return /enduristan\.nl\/?$/i.test(h.href); });
      var ym = /(20\d\d)/.exec(first);
      var year = dates ? dates.start.getFullYear() : (ym ? parseInt(ym[1], 10) : 0);
      var past = !!(dates && dates.end < today);
      if (!dates && year && cur.idx > -1) past = day(year, cur.idx + 1, 0) < today;
      var item = { date: dateTxt, dates: dates, year: year, month: cur, country: COUNTRIES[cKey] || country, name: name, href: href, place: place, hosts: hosts, nl: isNl, past: past, id: 'en-ev-' + all.length, order: all.length };
      cur.items.push(item);
      all.push(item);
    });

    function itemHtml(i) {
      var hostHtml = i.hosts.map(function (h) {
        return h.href ? '<a href="' + esc(h.href) + '" target="_blank" rel="noopener">' + esc(h.name) + '</a>' : esc(h.name);
      }).join(' ' + esc(L.lAnd || (EN ? 'and' : 'en')) + ' ');
      var o = '<li class="en-ev__item' + (i.nl ? ' is-nl' : '') + (i.past ? ' is-past' : '') + '" id="' + i.id + '"' + (i.nl ? ' data-nl' : '') + '>';
      o += '<div class="en-ev__date">' + esc(i.date) + '</div>';
      o += '<div class="en-ev__main">';
      if (i.past && L.lPast) o += '<span class="en-ev__badge en-ev__badge--past">' + esc(L.lPast) + '</span>';
      else if (i.nl && L.lNl) o += '<span class="en-ev__badge">' + esc(L.lNl) + '</span>';
      o += '<p class="en-ev__name">';
      o += i.href ? '<a href="' + esc(i.href) + '" target="_blank" rel="noopener" aria-label="' + esc(i.name + ', ' + (L.lMore || '')) + '">' + esc(i.name) + ARROW + '</a>' : esc(i.name);
      o += '</p>';
      o += '<p class="en-ev__where">' + PIN + '<span>' + esc([i.place, i.country].filter(Boolean).join(', ')) + '</span></p>';
      o += '</div>';
      if (hostHtml) o += '<div class="en-ev__host"><span>' + esc(L.lHosted || '') + '</span> ' + hostHtml + '</div>';
      return o + '</li>';
    }

    /* Groepen: blok = { key, name, idx, past, items, id } */
    function groupByMonth(items, suffix, isPast) {
      var map = {}, out = [];
      items.forEach(function (i) {
        var y = i.year || 0;
        var k = (i.month.idx > -1 ? y + '-' + i.month.idx : 'm' + i.month.n);
        if (!map[k]) { map[k] = { key: k, name: i.month.name, idx: i.month.idx, items: [], past: isPast, id: 'en-ev-g-' + suffix + '-' + out.length }; out.push(map[k]); }
        map[k].items.push(i);
      });
      return out;
    }
    function blockHtml(b) {
      var nl = b.items.some(function (i) { return i.nl; });
      var allPast = b.items.every(function (i) { return i.past; });
      var o = '<section class="en-ev__month' + (nl ? ' has-nl' : '') + (allPast ? ' is-past' : '') + '" id="' + b.id + '" data-en-ev-month>';
      if (b.name) o += '<h3 class="en-ev__mname"><span>' + esc(b.name) + '</span><span class="en-ev__mcount">' + b.items.length + '</span></h3>';
      o += '<ul class="en-ev__items" role="list">';
      b.items.forEach(function (i) { o += itemHtml(i); });
      return o + '</ul></section>';
    }

    var upcoming = all.filter(function (i) { return !i.past; });
    var gone = all.filter(function (i) { return i.past; });
    var blocks = [];
    var html = '';

    if (mode === 'mark') {
      /* Oorspronkelijke volgorde van de lijst */
      months.forEach(function (m) {
        if (!m.items.length && L.hideEmpty === 'true') return;
        var b = { name: m.name, idx: m.idx, items: m.items, id: 'en-ev-g-a-' + m.n };
        blocks.push(b);
        if (m.items.length) html += blockHtml(b);
        else html += '<section class="en-ev__month" id="' + b.id + '"><h3 class="en-ev__mname"><span>' + esc(m.name) + '</span></h3><ul class="en-ev__items" role="list"><li class="en-ev__none">-</li></ul></section>';
      });
    } else {
      upcoming.sort(function (x, y) { return (sortKey(x) - sortKey(y)) || (x.order - y.order); });
      var upBlocks = groupByMonth(upcoming, 'u', false);
      blocks = blocks.concat(upBlocks);
      if (upBlocks.length) {
        if (gone.length && L.lUpcoming) html += '<h2 class="en-ev__group">' + esc(L.lUpcoming) + '</h2>';
        upBlocks.forEach(function (b) { html += blockHtml(b); });
      } else if (L.lNoUpcoming) {
        html += '<p class="en-ev__empty">' + esc(L.lNoUpcoming) + '</p>';
      }
      if (gone.length && mode !== 'hide') {
        gone.sort(function (x, y) { return (sortKey(y) - sortKey(x)) || (y.order - x.order); });
        var pastBlocks = groupByMonth(gone, 'p', true);
        blocks = blocks.concat(pastBlocks);
        var open = mode === 'bottom_open' || !upBlocks.length;
        html += '<details class="en-ev__past" data-en-ev-past' + (open ? ' open' : '') + '>';
        html += '<summary class="en-ev__past-sum"><span class="en-ev__past-t">' + esc(L.lPastGroup || '') + '</span><span class="en-ev__mcount">' + gone.length + '</span><span class="en-ev__pm" aria-hidden="true"></span></summary>';
        html += '<div class="en-ev__past-body">';
        pastBlocks.forEach(function (b) { html += blockHtml(b); });
        html += '</div></details>';
      }
    }

    var shown = blocks.reduce(function (n, b) { return n + b.items.length; }, 0);
    if (!all.length) html = '<p class="en-ev__empty">' + esc(L.lEmpty || '') + '</p>';
    list.innerHTML = html;
    root.classList.add('is-ready');

    /* Filter Alle / Alleen Nederland */
    var filter = root.querySelector('[data-en-ev-filter]');
    var hasNl = !!list.querySelector('[data-nl]');
    function setFilter(v) {
      if (!filter) return;
      filter.querySelectorAll('[data-en-ev-f]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-en-ev-f') === v ? 'true' : 'false'); });
      root.classList.toggle('is-nl-only', v === 'nl');
    }
    if (filter && shown && hasNl) {
      filter.hidden = false;
      filter.addEventListener('click', function (e) {
        var b = e.target.closest('[data-en-ev-f]');
        if (b) setFilter(b.getAttribute('data-en-ev-f'));
      });
    }

    /* Datumzoeker */
    var bar = root.querySelector('[data-en-ev-bar]');
    var jump = root.querySelector('[data-en-ev-jump]');
    var dateIn = root.querySelector('[data-en-ev-date]');
    var nextBtn = root.querySelector('[data-en-ev-next]');
    var msg = root.querySelector('[data-en-ev-msg]');
    if (!bar || !shown) return;
    bar.hidden = false;

    function setBarH() { root.style.setProperty('--en-ev-bar', bar.offsetHeight + 'px'); }
    setBarH();
    window.addEventListener('resize', setBarH);

    function clearHits() { list.querySelectorAll('.is-hit').forEach(function (x) { x.classList.remove('is-hit'); }); }
    function say(t) { if (msg) { msg.textContent = t || ''; msg.hidden = !t; setBarH(); } }
    function go(el) {
      if (!el) return;
      var det = el.closest('details');
      if (det && !det.open) det.open = true;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    function markJump(btn) { if (!jump) return; jump.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-active', x === btn); }); }

    if (jump) {
      /* Een knop per maand, in kalendervolgorde; komend blok heeft voorrang boven afgelopen blok */
      var seen = {}, chips = [];
      blocks.forEach(function (b) {
        if (!b.name || !b.items.length) return;
        var k = b.idx > -1 ? b.idx : b.name;
        var up = b.items.some(function (i) { return !i.past; });
        if (seen[k]) { if (up && !seen[k].up) { seen[k].id = b.id; seen[k].up = true; } seen[k].nl = seen[k].nl || b.items.some(function (i) { return i.nl && !i.past; }); return; }
        seen[k] = { id: b.id, name: b.name, idx: b.idx, up: up, nl: b.items.some(function (i) { return i.nl && !i.past; }), order: b.idx > -1 ? b.idx : 99 + chips.length };
        chips.push(seen[k]);
      });
      chips.sort(function (x, y) { return x.order - y.order; });
      jump.innerHTML = chips.map(function (c) {
        return '<button type="button" class="en-ev__chip' + (c.up ? '' : ' is-past') + (c.nl ? ' has-nl' : '') + '" data-to="' + c.id + '">' + esc(c.name.slice(0, 3)) + '<span class="en-ev__vh">' + esc(c.name.slice(3)) + '</span></button>';
      }).join('');
      jump.addEventListener('click', function (e) {
        var b = e.target.closest('[data-to]');
        if (!b) return;
        clearHits(); say(''); setFilter('all'); markJump(b);
        go(document.getElementById(b.getAttribute('data-to')));
      });
    }

    var dated = all.filter(function (i) { return i.dates && document.getElementById(i.id); });
    function showItems(items, text) {
      clearHits(); setFilter('all'); markJump(null);
      items.forEach(function (i) { var el = document.getElementById(i.id); if (el) el.classList.add('is-hit'); });
      say(text);
      go(document.getElementById(items[0].id));
    }

    if (dateIn) {
      dateIn.addEventListener('change', function () {
        if (!dateIn.value) { clearHits(); say(''); return; }
        var p = dateIn.value.split('-');
        var d = day(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
        var hits = dated.filter(function (i) { return i.dates.start <= d && i.dates.end >= d; });
        if (hits.length) { showItems(hits, fill(L.lHits, { aantal: hits.length, datum: fmt(d) })); return; }
        var after = dated.filter(function (i) { return i.dates.start > d; }).sort(function (x, y) { return x.dates.start - y.dates.start; });
        if (after.length) { showItems([after[0]], fill(L.lNohit, { datum: fmt(d), naam: after[0].name, wanneer: fmt(after[0].dates.start) })); return; }
        clearHits(); say(fill(L.lNoneAfter, { datum: fmt(d) }));
      });
    }

    if (nextBtn) {
      var nxt = upcoming.filter(function (i) { return document.getElementById(i.id); })[0];
      if (mode === 'mark') nxt = upcoming.slice().sort(function (x, y) { return sortKey(x) - sortKey(y); })[0];
      if (!nxt) { nextBtn.hidden = true; }
      else {
        nextBtn.addEventListener('click', function () {
          showItems([nxt], fill(L.lNextMsg, { naam: nxt.name, wanneer: nxt.dates ? fmt(nxt.dates.start) : nxt.date }));
        });
      }
    }
  }

  function init() { document.querySelectorAll('[data-en-ev]').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
